/*
 * @Author: your name
 * @Date: 2021-04-13 15:24:26
 * @LastEditTime: 2021-04-13 15:30:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\assets\icons\index.js
 */
import Vue from 'vue'
import EcSvgIcon from '@/components/EcSvgIcon/src/index'// svg component

// register globally
Vue.component('ec-svg-icon', EcSvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)



// WEBPACK FOOTER //
// ./src/assets/icons/index.js